import { render, staticRenderFns } from "./PremiumClassTooltipDetail.vue?vue&type=template&id=78ce2262&"
import script from "./PremiumClassTooltipDetail.vue?vue&type=script&lang=js&"
export * from "./PremiumClassTooltipDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports